import { UsableFaxWithExtensionPipe } from '../../../../../_helpers/_pipes/usable-fax-with-extension.pipe';
import { ViewableExtensionPipe } from '../../../../../_helpers/_pipes/viewable-extension.pipe';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ClaimsNeedHelpComponent } from '../claims-need-help/claims-need-help.component';
import { UploadDocumentsSidebarComponent } from '../upload-documents-sidebar/upload-documents-sidebar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ClaimsDataService } from '../../../../../_services/_claims/claims-data.service';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyTypeService } from '../../../../../_services/_iam/company-type.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, UploadDocumentsSidebarComponent, ClaimsNeedHelpComponent, MapfreButtonComponent, ViewableExtensionPipe, UsableFaxWithExtensionPipe],
  selector: 'app-exposures-detail',
  templateUrl: './exposures-detail.component.html',
})
export class ExposuresDetailComponent implements OnInit {
  appraisalPending = false;
  claimid: string;
  claim: any;
  exposureNumber: string;
  exposure: any;
  paymentStatus: string;
  paymentToDate: number;
  payee: string;
  isAcmic = false;
  company: string;

  constructor(
    private claimsDataService: ClaimsDataService,
    private activeRoute: ActivatedRoute,
    private acmicService: AcmicService,
    private companyTypeService: CompanyTypeService
  ) {}

  getClaimExposure(exposures) {
    this.exposure = exposures.find(
      (exposure) =>
        exposure.exposureNumber.exposureNumber === this.exposureNumber
    );
  }
  getTotalPayments(claim) {
    claim.exposures.forEach((exposure) => {
      if (exposure.exposureNumber.exposureNumber === this.exposureNumber) {
        this.paymentToDate = 0;
        exposure.payments.forEach((payment) => {
          if (payment.checkPayee) {
            this.payee = payment.checkPayee;
          }
          this.paymentStatus = payment.status.code.toLowerCase();
          if(this.company!='TW'){
            if (this.paymentStatus === 'cashed' || this.paymentStatus === 'issued' || this.paymentStatus === 'cleared') {
              this.paymentToDate += parseFloat(payment.checkAmount);
            }
          }else{
            this.paymentToDate += parseFloat(payment.checkAmount);
          }
        });
      }
    });
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.activeRoute.params.subscribe((params: Params) => {
      this.claimid = params['id'].split('-')[0];
      this.exposureNumber = params['id'].split('-')[1];
    });
    this.claimsDataService.$claimsLossDetails.subscribe((claimsList) => {
      if (claimsList) {
        claimsList.forEach((claim) => {
          if (claim.number.number === this.claimid) {
            this.claim = claim;
            this.company = this.companyTypeService.getCompany(claim.policyNumber.policyNumber) ;
            if (claim.exposures) {
              this.getClaimExposure(claim.exposures);
              this.getTotalPayments(claim);
            }
          }
        });
      }
    });
  }
}
